var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:text-base text-sm",class:[_vm.align]},[_c('span',{staticClass:"font-bold text-white"},[_vm._v("*")]),_vm._v("\n    "+_vm._s(_vm.$t("common.required_fields_label"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }